module.exports = __webpack_public_path__ + "assets/img/link.eb6e9fe6.svg";